import type { FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { StickyContainer as StickyContainerUi } from "@jti/ui/components/StickyContainer/StickyContainer";

import { getBuilderChildrenCount } from "@/libs/builder/utils/getBuilderChildrenCount";

import { Placeholder } from "../Placeholder/Placeholder";

import type { stickyContainerInputs } from "./StickyContainer.builder";

import styles from "./StickyContainer.module.scss";

export type StickyContainerProps = BuilderComponentProps<typeof stickyContainerInputs>;

export const StickyContainer: FC<PropsWithChildren<StickyContainerProps>> = ({ position, children }) => {
  if (isEditing()) {
    return (
      <div className={styles.authoringContainer}>
        {getBuilderChildrenCount(children) === 0 && <Placeholder>Drag and drop component here</Placeholder>}
        {children}
      </div>
    );
  }
  return <StickyContainerUi position={position}>{children}</StickyContainerUi>;
};
